import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info with New PSN Logo */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_digital-home-48/artifacts/km5sisnl_PSN%20LOGO%20-%20Canvas%20%234.png" 
                alt="Professional Services Nationwide Logo" 
                className="h-20 w-auto object-contain"
                style={{ border: 'none', maxWidth: '350px' }}
                data-testid="footer-company-name"
              />
            </div>
            <p className="text-gray-400 mb-4 text-base">
              Your trusted partner for comprehensive business solutions. We empower businesses
              with professional services tailored to meet your unique needs.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3 text-gray-400">
                <Phone size={18} />
                <a href="tel:+19547789764" className="hover:text-white transition-colors" data-testid="footer-phone">
                  (954) 778-9764
                </a>
              </div>
              <div className="flex items-center space-x-3 text-gray-400">
                <Mail size={18} />
                <a href="mailto:info@professionalservicesnationwide.com" className="hover:text-white transition-colors" data-testid="footer-email">
                  info@professionalservicesnationwide.com
                </a>
              </div>
              <div className="flex items-center space-x-3 text-gray-400">
                <MapPin size={18} />
                <span data-testid="footer-address">Nationwide Coverage, USA</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/why-psn" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-why-psn">
                  Why PSN
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Bookkeeping & Accounting</li>
              <li>Payroll Services</li>
              <li>Business Automation</li>
              <li>Notary Services</li>
              <li>Estate Planning</li>
              <li>Insurance Solutions</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400" data-testid="footer-copyright">
            © {currentYear} Professional Services Nationwide. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;